/*
 * PRESET-BUILDS: lets a product page hand a ready-made Industry Nine System build to the Custom Wheel Builder.
 *
 * Two entry points (both carry the same JSON "preset", see sanitize()):
 *   Customize:   /pages/custom-wheel-builder#prebuild=<URI-encoded JSON>    -> builder opens at Step 2 with the page's choices filled in
 *   Add to cart: /pages/custom-wheel-builder?preset=<base64url JSON>&step=3 -> (release 6) builder loads the same state behind a "Loading your build..." screen and
 *                stops at STEP 3 with every part selected and a note ("Your build is loaded. Add valve stems if you want them, then press Add Build to Cart.").
 *                The customer presses the builder's normal Add Build to Cart (its own validation and cart code), then goes to the accessories page.
 *                An old link ending in &add=1 now does the same (it never adds by itself any more).
 *
 * JSON shape (v:1):
 *   { selections: { step1: { buildType:'Wheel Set', ridingStyle:'mtb', ridingStyleDisplay:'Mountain', spokeInterface:'system' },
 *                   step2: { systemHub, frontWheelSize, rearWheelSize, frontSpokeCount, rearSpokeCount, brakeStyle,
 *                            frontHubSpacing, rearHubSpacing, freehubType } },
 *     preset: { v:1, family:'<code>', title:'<product title>', frontRim:'<variant id>', rearRim:'<variant id>',
 *               hubColor:'Black', spokeColor:'Black', locked:['systemHub','frontWheelSize','rearWheelSize','frontSpokeCount','rearSpokeCount'] } }
 *
 * Nothing here is saved into the build (getCleanBuildStateForSaving ignores buildState.preset), so a preset order is byte-for-byte a builder order.
 * A value the builder does not offer is dropped and reported ("not chosen"), never replaced.
 */
(function (global) {
  'use strict';

  var VERSION = 1;
  var STEP2_KEYS = ['systemHub', 'frontWheelSize', 'rearWheelSize', 'frontSpokeCount', 'rearSpokeCount', 'brakeStyle', 'frontHubSpacing', 'rearHubSpacing', 'freehubType'];
  var DEFAULT_LOCKED = ['systemHub', 'frontWheelSize', 'rearWheelSize', 'frontSpokeCount', 'rearSpokeCount'];
  var LABELS = { systemHub: 'hub model', frontWheelSize: 'front wheel size', rearWheelSize: 'rear wheel size', frontSpokeCount: 'front hole count', rearSpokeCount: 'rear hole count', brakeStyle: 'brake style', frontHubSpacing: 'front hub spacing', rearHubSpacing: 'rear hub spacing', freehubType: 'freehub', frontRim: 'front rim', rearRim: 'rear rim', hubColor: 'hub color', spokeColor: 'spoke color' };

  function B() { return global.__loamBuilderInternals; }
  function bs() { var b = B(); return b ? b.buildState : null; }
  function fn(name) { var b = B(); return b && b.fns ? b.fns[name] : null; }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function str(v, max) { return typeof v === 'string' ? v.slice(0, max || 80) : null; }
  function digits(v) { var s = String(v == null ? '' : v).replace(/\D/g, ''); return s ? s.slice(0, 20) : null; }

  /* ------------------------------------------------------------------ encoding */
  function toBase64Url(text) {
    var bytes = new TextEncoder().encode(text), bin = '';
    for (var i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function fromBase64Url(s) {
    var b = String(s).replace(/-/g, '+').replace(/_/g, '/'); while (b.length % 4) b += '=';
    var bin = atob(b), bytes = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return new TextDecoder().decode(bytes);
  }

  // Whitelist everything that comes from a URL: only known keys, only short strings. Returns null when it is not a System preset.
  function sanitize(raw) {
    if (!raw || typeof raw !== 'object') return null;
    var sel = raw.selections || {}, s1 = sel.step1 || {}, s2 = sel.step2 || {}, p = raw.preset || {};
    if (s1.spokeInterface !== 'system') return null;
    var out = { step1: { buildType: 'Wheel Set', ridingStyle: str(s1.ridingStyle, 20) || 'mtb', ridingStyleDisplay: str(s1.ridingStyleDisplay, 40) || 'Mountain', spokeInterface: 'system' }, step2: {}, preset: null };
    STEP2_KEYS.forEach(function (k) { var v = str(s2[k], 40); if (v) out.step2[k] = v; });
    var locked = Array.isArray(p.locked) ? p.locked.filter(function (k) { return STEP2_KEYS.indexOf(k) >= 0; }) : DEFAULT_LOCKED.slice();
    out.preset = { v: VERSION, family: str(p.family, 60), title: str(p.title, 140), frontRim: digits(p.frontRim), rearRim: digits(p.rearRim), hubColor: str(p.hubColor, 20), spokeColor: str(p.spokeColor, 20), locked: locked };
    return out;
  }
  // The builder (and the product page) both use this to make the link. preset is the same object that sanitize() reads.
  function hashFor(raw) { return '#prebuild=' + encodeURIComponent(JSON.stringify(raw)); }
  function searchFor(raw) { return '?preset=' + toBase64Url(JSON.stringify(raw)) + '&step=3'; }

  function fromSearch() {
    var q = new URLSearchParams(global.location.search), v = q.get('preset');
    if (!v) return null;
    try { var clean = sanitize(JSON.parse(fromBase64Url(v))); return clean ? { data: clean, step3: q.get('step') === '3' || q.get('add') === '1' } : null; } catch (e) { return null; }
  }
  // Called by handlePrebuildState with the parsed #prebuild JSON; returns the clean data when it is a System preset.
  function fromPrebuild(raw) { return raw && raw.preset ? sanitize(raw) : null; }

  /* ------------------------------------------------------------------ state */
  function adopt(clean) {
    var s = bs(); if (!s || !clean) return false;
    // Choosing I9 System in Step 1 makes the builder switch riding style to Hybrid (the road drivers XD-R / HG-R are tagged gravel/road and the
    // mtb-only filter would hide them), so a preset does the same whatever riding style the page sent.
    s.ridingStyle = 'hybrid'; s.ridingStyleDisplay = 'Hybrid: Gr/Rd/Mtb'; s.buildType = clean.step1.buildType;
    s.spokeInterface = 'system';
    s.specs = Object.assign({}, s.specs, clean.step2);
    s.preset = clean.preset; s.preset.notChosen = []; s.preset.notes = []; s.preset.wanted = Object.assign({}, clean.step2); s.preset.stepMissing = [];
    return true;
  }
  function active() { var s = bs(); return !!(s && s.preset); }
  // The page's lock is only in force while the rims are still the preset's rims (changing the rim leaves the preset).
  function locksOn() {
    var s = bs(); if (!s || !s.preset) return false;
    var f = s.components.frontRim, r = s.components.rearRim, p = s.preset;
    if (f && p.frontRim && digits(f.variantId) !== p.frontRim) return false;
    if (r && p.rearRim && digits(r.variantId) !== p.rearRim) return false;
    return true;
  }

  /* ------------------------------------------------------------------ notices and the Adding screen */
  function banner(html, kind) {
    var host = document.getElementById('variant-builder-container'); if (!host) return;
    var el = document.getElementById('preset-builds-notice');
    if (!el) { el = document.createElement('div'); el.id = 'preset-builds-notice'; host.insertBefore(el, host.firstChild); }
    el.className = 'preset-builds-notice' + (kind ? ' is-' + kind : '');
    el.innerHTML = html; el.style.display = html ? '' : 'none';
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function showOverlay() {
    var el = document.getElementById('preset-builds-overlay');
    if (!el) {
      el = document.createElement('div'); el.id = 'preset-builds-overlay'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
      el.innerHTML = '<div class="preset-builds-overlay__box"><div class="preset-builds-wait"><span></span></div><p class="preset-builds-overlay__title">Loading your build&hellip;</p><p class="preset-builds-overlay__sub">One moment, we are filling in the parts.</p></div>';
      document.body.appendChild(el);
    }
    el.style.display = 'flex';
  }
  function hideOverlay() { var el = document.getElementById('preset-builds-overlay'); if (el) el.style.display = 'none'; }
  // What the page chose but the builder does not have right now: a spec that is empty although the page set it (dropped by the validity pass or by the
  // builder's own rules, e.g. a freehub not offered for the chosen spacing), plus what Step 3 could not select. Recomputed every time, so a fixed choice leaves the list.
  function computeNotChosen() {
    var s = bs(); if (!s || !s.preset) return [];
    var p = s.preset, out = [];
    var auto = (s._ui && s._ui.step2AutoSelected) || {};
    p.replaced = {};
    Object.keys(p.wanted || {}).forEach(function (k) {
      if (!s.specs[k]) out.push(k);
      // the builder pre-selects a lone offered value (e.g. the only freehub for a spacing): that is the builder's pick, not the page's choice
      else if (s.specs[k] !== p.wanted[k] && auto[k]) { out.push(k); p.replaced[k] = s.specs[k]; }
    });
    (p.stepMissing || []).forEach(function (k) { if (out.indexOf(k) < 0) out.push(k); });
    p.notChosen = out; return out;
  }
  function notChosenText(p) {
    var parts = (p.notChosen || []).map(function (k) { return (LABELS[k] || k) + (p.replaced && p.replaced[k] ? ' (the builder pre-selected ' + p.replaced[k] + ', please check)' : ''); });
    return parts.length ? 'These choices from the product page are not available, so they are not chosen yet: <strong>' + esc(parts.join(', ')) + '</strong>.' : '';
  }
  function refreshBanner() {
    var s = bs(); if (!s || !s.preset) { banner(''); return; }
    computeNotChosen();
    var msg = notChosenText(s.preset), notes = (s.preset.notes || []).map(esc).join(' ');
    var head = s.preset.title ? '<strong>' + esc(s.preset.title) + '</strong>: your choices are filled in. ' : 'Your choices from the product page are filled in. ';
    if (s.preset.loaded) head = '<strong>Your build is loaded.</strong> Add valve stems if you want them, then press Add Build to Cart. ';
    else if (locksOn()) head += 'The hub model, wheel size and hole count come from that product. ';
    banner(head + (msg ? '<br>' + msg : '') + (notes ? '<br>' + notes : ''), msg || notes ? 'warn' : 'info');
  }

  /* ------------------------------------------------------------------ Step 2: validity pass and locks */
  // The Step 2 freehub row's data-spec-group is "freehub", the spec key is "freehubType"; every other row uses the spec key.
  function groupOf(key) { return key === 'freehubType' ? 'freehub' : key; }
  function specButton(key, value) {
    var all = document.querySelectorAll('[data-spec-group="' + groupOf(key) + '"]');
    for (var i = 0; i < all.length; i++) if (all[i].dataset.value === value) return all[i];
    return null;
  }
  // Drops every preset spec the builder does not offer right now (no button, or the button is marked unavailable). Order follows the Step 2 rows
  // because dropping the hub model changes what the later rows offer.
  function validateSpecs() {
    var s = bs(); if (!s || !s.preset) return [];
    var dropped = [];
    STEP2_KEYS.forEach(function (k) {
      var v = s.specs[k]; if (!v) return;
      var btn = specButton(k, v);
      if (!btn || btn.classList.contains('is-unavailable') || btn.disabled) { s.specs[k] = null; dropped.push(k); }
    });
    computeNotChosen();
    return dropped;
  }
  function applyLocks() {
    var s = bs(); if (!s || !s.preset) return;
    var on = locksOn();
    document.querySelectorAll('[data-spec-group]').forEach(function (btn) {
      var locked = on && s.preset.locked.indexOf(btn.dataset.specGroup) >= 0;
      btn.classList.toggle('preset-locked', locked);
      if (locked) btn.setAttribute('title', 'Set by the product you chose. Change the rim in Step 3 or start a custom build to change it.'); else if (btn.classList.contains('preset-locked') === false && btn.title && btn.title.indexOf('Set by the product') === 0) btn.removeAttribute('title');
    });
  }
  var blockerInstalled = false;
  function installBlocker() {
    if (blockerInstalled) return; blockerInstalled = true;
    // capture phase: a locked button never reaches the builder's own click handler
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-spec-group].preset-locked');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    }, true);
    // Step 2 redraws its rows after data arrives or a spec changes: re-apply the locks to the new buttons (childList only, so the class changes below do not loop)
    var step2 = document.getElementById('step-2'), timer = null;
    if (step2 && typeof MutationObserver === 'function') new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(function () { applyLocks(); refreshBanner(); }, 60); }).observe(step2, { childList: true, subtree: true });
  }
  function redrawStep2() {
    ['renderStep2', 'updateStep2OptionsVisibility', 'updateStep2VisualFeedback', 'updateSpecAvailabilityCounters', 'updateFreehubLockUI'].forEach(function (n) { var f = fn(n); if (f) f(); });
  }
  // Called by showStep(2) after the row is drawn.
  function afterStep2Render() {
    var s = bs(); if (!s || !s.preset) return;
    installBlocker();
    if (!s.preset._specsChecked && dataReady()) {
      s.preset._specsChecked = true;
      redrawStep2(); // the row may have been drawn before the data arrived: check against a fresh availability state
      var dropped = validateSpecs();
      if (dropped.length) { redrawStep2(); fn('validateStep2')(); }
    }
    applyLocks(); refreshBanner();
  }
  function dataReady() {
    var b = B(); if (!b) return false;
    var c = b.caches; return !!(c.rims.length && c.hubs.length);
  }

  /* ------------------------------------------------------------------ Step 3: select the rims, hub and colors */
  async function clickVariant(pos, type, gid) {
    var cont = document.getElementById(pos + '-' + type + '-options-container'); if (!cont) return false;
    var sel = '.component-variant-button[data-variant-id="' + gid + '"]';
    var btn = cont.querySelector(sel);
    if (!btn) {
      var heads = cont.querySelectorAll('.component-product-card .product-card-header');
      for (var i = 0; i < heads.length && !btn; i++) { heads[i].click(); await wait(150); btn = cont.querySelector(sel); }
    }
    if (!btn) return false;
    btn.click(); return true;
  }
  async function waitFor(test, ms) { var end = Date.now() + (ms || 5000); while (Date.now() < end) { if (test()) return true; await wait(100); } return test(); }
  function hubVariantFor(pos, color) {
    var s = bs(), b = B(), spacing = s.specs[pos + 'HubSpacing'], count = s.specs[pos + 'SpokeCount'], norm = b.fns.normalizeSpacing;
    var hubs = b.caches.hubs, P = pos === 'front' ? 'Front' : 'Rear';
    for (var i = 0; i < hubs.length; i++) {
      var vs = hubs[i].variants || [];
      for (var j = 0; j < vs.length; j++) {
        var v = vs[j]; if (!v.availableForSale && v.availableForSale !== undefined) continue;
        if (v.spec_position !== P && v.spec_position !== 'Front/Rear') continue;
        var c = (v.selectedOptions || []).filter(function (o) { return o.name.toLowerCase() === 'color'; })[0];
        if (c && color && c.value !== color) continue;
        if (count && String(v.spec_spoke_count) !== String(count)) continue;
        if (spacing && norm(v.spec_hub_spacing) !== norm(spacing)) continue;
        return v.id;
      }
    }
    return null;
  }
  // Returns { ok, notes } and records what could not be applied on buildState.preset.
  async function applyAtStep3() {
    var s = bs(); if (!s || !s.preset || s.preset._applied) return { ok: true, notes: [] };
    var p = s.preset, notes = [], ok = true; p._applied = true;
    var positions = ['front', 'rear'];
    function missing(k, why) { ok = false; if (p.stepMissing.indexOf(k) < 0) p.stepMissing.push(k); if (why) notes.push(why); }
    // rims (clicking the front rim pairs the rear one; the rear is clicked only when it still differs)
    var want = { front: p.frontRim, rear: p.rearRim || p.frontRim };
    for (var i = 0; i < positions.length; i++) {
      var pos = positions[i], id = want[pos], key = pos + 'Rim';
      if (!id) { missing(key); continue; }
      var cur = s.components[key];
      if (!cur || digits(cur.variantId) !== id) {
        var clicked = await clickVariant(pos, 'rim', 'gid://shopify/ProductVariant/' + id);
        if (clicked) await waitFor(function () { var c = s.components[key]; return c && digits(c.variantId) === id; }, 4000);
      }
      var now = s.components[key];
      if (!now || digits(now.variantId) !== id) missing(key, 'The ' + pos + ' rim from the product page is not offered for the chosen size and hole count.');
    }
    // The rear hub's freehub body is a separate component product. It must be loaded BEFORE a hub is clicked, or the builder drops the freehub line.
    if (s.specs.freehubType) {
      var bb = B();
      if (!bb.caches.freehubs.length) {
        if (!bb.componentFetchPromises.freehubs && bb.fns.fetchFreehubComponentProducts) bb.componentFetchPromises.freehubs = bb.fns.fetchFreehubComponentProducts(); // only the freehub list (the full early fetch would also reload rims and hubs)
        try { if (bb.componentFetchPromises.freehubs) await bb.componentFetchPromises.freehubs; } catch (e) { /* checked below */ }
        await waitFor(function () { return bb.caches.freehubs.length > 0; }, 10000);
      }
      if (!bb.caches.freehubs.length) { missing('freehubType', 'The freehub list did not load.'); }
    }
    // hubs (front first, the builder pairs the rear hub)
    var color = p.hubColor || 'Black';
    for (var h = 0; h < positions.length; h++) {
      var hp = positions[h], hkey = hp + 'Hub', cur2 = s.components[hkey];
      var hid = hubVariantFor(hp, color);
      if (!hid) { missing('hubColor', 'No ' + hp + ' hub in ' + color + ' matches the chosen hub spacing and hole count.'); continue; }
      if (!cur2 || cur2.variantId !== hid) {
        var ok2 = await clickVariant(hp, 'hub', hid);
        if (ok2) await waitFor(function () { var c = s.components[hkey]; return c && c.variantId === hid; }, 4000);
      }
      var nowHub = s.components[hkey];
      if (!nowHub || nowHub.variantId !== hid) missing(hp === 'front' ? 'frontHubSpacing' : 'rearHubSpacing', 'The ' + hp + ' hub could not be selected.');
    }
    if (s.specs.freehubType && s.components.rearHub && !s.components.rearComponentFreehub) missing('freehubType', 'The ' + s.specs.freehubType + ' freehub is not offered for this hub.');
    // spoke color (solid, both wheels)
    var sc = p.spokeColor;
    if (sc && global.I9System && sc !== 'Black') {
      positions.forEach(function (pos2) { try { global.I9System._applyBaseChange(pos2, sc, 'all'); } catch (e) { notes.push('The spoke color could not be set.'); } });
    }
    p.notes = (p.notes || []).concat(notes);
    return { ok: ok, notes: notes };
  }

  /* ------------------------------------------------------------------ Add to cart: open the builder at Step 3 (release 6: nothing is added here) */
  function failToStep2(reason) {
    hideOverlay();
    var s = bs(); if (s && s.preset) { s.preset._applied = false; s.preset.notes = (s.preset.notes || []).concat(reason ? [reason] : []); }
    var f = fn('showStep'); if (f) f(2);
    setTimeout(function () {
      banner('<strong>We could not load this build completely.</strong> ' + esc(reason || 'One of the choices is not available.') + ' Your choices are filled in below, please check them and continue.', 'warn');
    }, 400);
  }
  async function runToStep3() {
    showOverlay();
    var s = bs();
    try {
      await fn('showStep')(2, { skipScroll: true });
      var b = B(); var pf = global.I9System && global.I9System._prefetchState;
      await waitFor(function () { return dataReady() && !(pf && pf.promise); }, 25000);
      await wait(400);
      if (!dataReady()) return failToStep2('The component list did not load. Please try again.');
      afterStep2Render();
      afterStep2Render(); computeNotChosen();
      if (s.preset.notChosen.length || !fn('validateStep2')()) return failToStep2('Some choices from the product page are not available right now.');
      await fn('showStep')(3, { skipScroll: true });
      var res = await applyAtStep3();
      fn('validateStep3')();
      if (!res.ok || !fn('validateStep3')()) return failToStep2(res.notes[0] || 'The build is not complete.');
      s.preset.loaded = true; hideOverlay(); refreshBanner(); // the customer adds valve stems if wanted and presses the builder's normal Add Build to Cart
    } catch (e) {
      if (global.console) global.console.warn('[PRESET] load failed: ' + (e && e.message));
      failToStep2('Something went wrong while preparing the build.');
    }
  }

  /* ------------------------------------------------------------------ price after SYSTEM10 (used by the product-price check and the tests) */
  // The store's automatic discount SYSTEM10: 10% off the products of three smart collections, minimum quantity 6 of those items; a $0 line is not counted.
  // Shopify takes the percentage per unit and drops the fraction of a cent (the builder's own estimate does the same: Math.floor on cents).
  // lines: [{ cents, qty, inCollection }]. Returns { listCents, discountCents, totalCents, counted, applies }.
  var SYSTEM10 = { percent: 10, minQuantity: 6 };
  function systemPrice(lines) {
    var list = 0, counted = 0, disc = 0;
    lines.forEach(function (l) { list += l.cents * l.qty; if (l.inCollection && l.cents > 0) counted += l.qty; });
    var applies = counted >= SYSTEM10.minQuantity;
    if (applies) lines.forEach(function (l) { if (l.inCollection && l.cents > 0) disc += Math.floor(l.cents * SYSTEM10.percent / 100) * l.qty; });
    return { listCents: list, discountCents: disc, totalCents: list - disc, counted: counted, applies: applies };
  }

  function injectStyles() {
    if (document.getElementById('preset-builds-styles')) return;
    var st = document.createElement('style'); st.id = 'preset-builds-styles';
    st.textContent = '#preset-builds-overlay{position:fixed;inset:0;z-index:100000;background:rgba(255,255,255,.985);display:none;align-items:center;justify-content:center;text-align:center;padding:24px}' +
      '.preset-builds-overlay__box{max-width:360px}.preset-builds-overlay__title{font-size:2.4rem;font-weight:700;margin:18px 0 8px}.preset-builds-overlay__sub{margin:0;font-size:1.5rem;opacity:.8}' +
      '.preset-builds-wait{width:44px;height:44px;margin:0 auto;border:4px solid #d9dde3;border-top-color:#111;border-radius:50%;animation:presetspin 0.9s linear infinite}@keyframes presetspin{to{transform:rotate(360deg)}}' +
      '.preset-builds-notice{margin:0 0 16px;padding:12px 16px;border-radius:6px;background:#eef4ff;border:1px solid #b9cdf2;font-size:1.4rem;line-height:1.5}.preset-builds-notice.is-warn{background:#fff6e5;border-color:#f0c36d}' +
      '#variant-builder-container [data-spec-group].preset-locked{opacity:.85;cursor:not-allowed!important}';
    document.head.appendChild(st);
  }
  if (document.head) injectStyles(); else document.addEventListener('DOMContentLoaded', injectStyles);

  global.PresetBuilds = {
    VERSION: VERSION, sanitize: sanitize, hashFor: hashFor, searchFor: searchFor, toBase64Url: toBase64Url, fromBase64Url: fromBase64Url,
    fromSearch: fromSearch, fromPrebuild: fromPrebuild, adopt: adopt, active: active, locksOn: locksOn,
    validateSpecs: validateSpecs, afterStep2Render: afterStep2Render, applyAtStep3: applyAtStep3, runToStep3: runToStep3, refreshBanner: refreshBanner,
    showOverlay: showOverlay, hideOverlay: hideOverlay, systemPrice: systemPrice, SYSTEM10: SYSTEM10
  };
})(window);
